// Deterministic per-name avatar color + initials, shared by every place
// that shows a patient avatar (patients table, patient view, payments
// view) so they all pick the same color for the same patient.
const AVATAR_PALETTE = ["#1E88E5", "#8E24AA", "#00897B", "#F4511E", "#3949AB", "#43A047"];

export function colorForName(name = "") {
    const sum = [...name].reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
    return AVATAR_PALETTE[sum % AVATAR_PALETTE.length];
}

export function initialsFor(name = "") {
    const parts = name.trim().split(/\s+/);
    return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
}
